// import React from "react";
// import { useEffect } from "react";
// import { RouterProvider } from "react-router-dom";
// import routes from "./Routes";
// import { Provider } from "react-redux";
// import {store} from "./components/redux/store";
// import { useDispatch, useSelector } from 'react-redux';
// import { loadAllNetworks } from './components/redux/friendSlice';

// const App = () => {
//   const dispatch = useDispatch();
//     const dataLoaded = useSelector(state => state.friend.dataLoaded);
    
//     useEffect(() => {
//         const token = localStorage.getItem('token');
//         if (token && !dataLoaded) {
//             // ✅ एक बार सभी lists load करें
//             dispatch(loadAllNetworks());
//         }
//     }, [dispatch, dataLoaded]);
//   return <>
//     <Provider store={store}>
//       <RouterProvider router={routes} />;
//     </Provider>
//   </>
// };

// export default App;

// import React, { useEffect } from "react";
// import { RouterProvider } from "react-router-dom";
// import routes from "./Routes";
// import { Provider, useDispatch, useSelector } from "react-redux";
// import { store } from "./components/redux/store";
// import { loadAllNetworks } from "./components/redux/friendSlice";
// // import { useInitUser } from './components/hooks/useInitUser';
// import { AuthProvider } from './components/context/AuthContext';
// import { ScreenShareProvider } from './components/context/ScreenShareContext';
// import { Analytics } from '@vercel/analytics/react';
  
// const AppContent = () => {
//   const dispatch = useDispatch();
//   const dataLoaded = useSelector(state => state.friend.dataLoaded);
//   // useInitUser();
  
//   useEffect(() => {
//     const token = localStorage.getItem("token");
//     if (token && !dataLoaded) {
//       dispatch(loadAllNetworks());
//     }
//   }, [dispatch, dataLoaded]);

//   return <RouterProvider router={routes} />;
// };

// const App = () => {
//   return (
//     <Provider store={store}>
//       <ScreenShareProvider>
//       <AuthProvider>
//       <AppContent />
//       </AuthProvider>
//       {process.env.NODE_ENV === 'production' && <Analytics />}
//       </ScreenShareProvider>
//     </Provider>
//   );
// };

// export default App;




import { useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import routes from "./Routes";
import { Provider, useDispatch, useSelector } from "react-redux";
import { store } from "./components/redux/store";
import { loadAllNetworks } from "./components/redux/friendSlice";
import { AuthProvider, useAuth } from './components/context/AuthContext';
import { ScreenShareProvider } from './components/context/ScreenShareContext';
import { CallProvider } from './components/context/CallContext';
import AudioCall from './components/shared/AudioCall';
import { Analytics } from '@vercel/analytics/react';
// import DebugPanel from '../src/components/extra/DebugPanel';
import { GoogleOAuthProvider } from "@react-oauth/google";

// This component needs to be inside AuthProvider to access useAuth
const AppWithProviders = () => {
  const { userId } = useAuth();
  const dispatch = useDispatch();
  const dataLoaded = useSelector(state => state.friend.dataLoaded);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token && !dataLoaded) {
      dispatch(loadAllNetworks());
    }
  }, [dispatch, dataLoaded]);

  return (
    <CallProvider userId={userId}>
      <AudioCall />
        {/* <DebugPanel /> */}
      <RouterProvider router={routes} />
    </CallProvider>
  );
};

const App = () => {
  return (
    <Provider store={store}>
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <AuthProvider>
        <ScreenShareProvider>
          <AppWithProviders />
          {process.env.NODE_ENV === 'production' && <Analytics />}
        </ScreenShareProvider>
      </AuthProvider>
      </GoogleOAuthProvider>

    </Provider>
  );
};

export default App;